import { render } from "./Footer.vue?vue&type=template&id=d5360994&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=d5360994&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5360994"]])

export default __exports__